import tree_small from '../../VUE/src/pages/oni-mansion-game/assets/tree_small.png';
import tree_small_json from '../../VUE/src/pages/oni-mansion-game/assets/tree_small.json';
import tree from '../../VUE/src/pages/oni-mansion-game/assets/tree.png';
import tree_json from '../../VUE/src/pages/oni-mansion-game/assets/tree.json';
import candle from '../../VUE/src/pages/oni-mansion-game/assets/candle.png';
import candle_json from '../../VUE/src/pages/oni-mansion-game/assets/candle.json';
import candle_small from '../../VUE/src/pages/oni-mansion-game/assets/candle_small.png';
import candle_small_json from '../../VUE/src/pages/oni-mansion-game/assets/candle_small.json';
import loading_gif from '../../VUE/src/pages/oni-mansion-game/assets/loading_gif.png';
import loading_gif_json from '../../VUE/src/pages/oni-mansion-game/assets/loading_gif.json';

export const HOUSE_PREVIEW_ATLAS_CONFIG = [
  {
    name: 'loading_gif',
    image: loading_gif,
    json: loading_gif_json,
    multiatlas: false,
  },
  {
    name: 'tree',
    image: tree,
    json: tree_json,
    multiatlas: false,
  },
  {
    name: 'candle',
    image: candle,
    json: candle_json,
    multiatlas: false,
  },
  {
    name: 'tree_small',
    image: tree_small,
    json: tree_small_json,
    multiatlas: false,
  },
  {
    name: 'candle_small',
    image: candle_small,
    json: candle_small_json,
    multiatlas: false,
  },
];
